import React from 'react';
import ReactDOM from 'react-dom';
import * as firebase from 'firebase';
import 'semantic-ui-css/semantic.min.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyDHm_yDEgHwCzsE6yLcvRP-1jOyiW6TVxE',
  authDomain: 'pearl-news.firebaseapp.com',
  databaseURL: 'https://pearl-news.firebaseio.com',
  projectId: 'pearl-news',
  storageBucket: 'pearl-news.appspot.com',
  messagingSenderId: '862685425134',
};
firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js